import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const strNumbersWrap = document.querySelectorAll('.p-str__items__number');
if (strNumbersWrap) {
  strNumbersWrap.forEach(wrap => {
    let numberTl = gsap.timeline({
      scrollTrigger: {
        scrub: 2,
        trigger: wrap,
        start: 'top bottom',
        end: () => '+=' + (wrap.clientHeight),
        invalidateOnRefresh: true,
        // markers: true
      }
    })

    let circle = wrap.querySelector('.p-str__img--circle');
    gsap.set(circle, {
      scale: 3,
      opacity: 0,
      rotate: 0
    })

    numberTl.add('start')
      .to(circle, {
        scale: 1,
        opacity: 1,
        rotate: 360,
      })
  })
}

const strMediaMain = document.querySelector('.p-str__img--main__picture');
if (strMediaMain) {
  let strMediaMainTl = gsap.timeline({
    scrollTrigger: {
      scrub: 2,
      trigger: strMediaMain,
      start: 'top center',
      end: () => '+=' + (strMediaMain.clientHeight),
      invalidateOnRefresh: true,
      // markers: true,
    }
  })

  let inner = strMediaMain.querySelector('.p-str__img--main');

  gsap.set(inner, {
    objectPosition: '0 0%',
  })

  strMediaMainTl.add('start')
    .to(inner, {
      objectPosition: '0 100%',
    })
}